import styled from 'styled-components';

export default styled.section`
  background: ${props => props.theme.colors.blue10};
  margin-top: 5rem;
  overflow: visible !important;

  @media (max-width: ${props => props.theme.breakpoints.desktop}) {
    margin-top: 2rem;
    width: 100vw;
    margin-left: calc(((100vw - 100%) / 2) * -1);
  }

  @media (prefers-reduced-motion: no-preference) {
    .isAnimated& {
      opacity: 0;
      transition: all 0.4s ease-in-out;
      transform: translateY(10px);
    }
  }

  .active& {
    opacity: 1;
    transform: none;
  }

  .inner {
    margin: auto;
    max-width: ${props => props.theme.maxWidths.containerSmall};
    padding: 0 ${props => props.theme.padding.inner};

    @media (min-width: ${props => props.theme.breakpoints.desktop}) {
      padding: 0 1.5rem;
    }
  }

  header {
    display: block;
    margin: 0;
    padding: 0;
    transform: translateY(-50%);

    h2 {
      padding: 0.5rem 1rem;
      margin: 0;
      background: ${props => props.theme.colors.claytonBlue};
      border-radius: calc(1em + 0.5rem);
      display: inline-block;
      color: ${props => props.theme.colors.white};
      font-size: ${props => props.theme.type.label.large};
      letter-spacing: ${props => props.theme.letterSpacing.label};
      line-height: ${props => props.theme.lineHeights.label.large};
      text-transform: uppercase;
    }
  }

  .content {
    padding: 0.5rem 0 1.5rem;

    > * {
      &:first-child {
        margin-top: 0;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  a {
    color: ${props => props.theme.colors.vmfBlue};
    transition: all 0.2s ease-in-out;

    &:active,
    &:hover,
    &:focus {
      color: ${props => props.theme.colors.vmfGreen2};
    }
  }
`;
